class RadioField extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var style = {};

        if (this.props.stacklabel) {
            style.margin = "2px 10px 0 10px";
        }

        let radios = [];
        for (let i = 0; i < this.props.radios.length; i++) {
            let radio = this.props.radios[i];
            if (!radio.text || radio.text == "") {
                radio.text = "empty";
                style.display = "none";
            }
            radios.push(
                this.props.isvertical == true ?
                    <label className="" key={i}>
                        <input
                            key={radio.value + i}
                            disabled={this.props.disabled ? true : false}
                            type="radio"
                            checked={this.props.value == radio.value ? true : false}
                            value={radio.value}
                            onChange={(e) => { this.props.onFieldChanged(e.target.value); }}
                            className={this.props.error == true ? "inputError sub-free-radio" : "sub-free-radio"}
                        />
                        {<span dangerouslySetInnerHTML={{ __html: radio.text }}></span>}
                        {this.props.isvertical ? <br /> : ""}
                    </label>
                    :
                    <div className="inline-radios" key={i} style={style}>
                        <label>
                            <input
                                key={radio.value + i}
                                disabled={this.props.disabled ? true : false}
                                type="radio"
                                checked={this.props.value == radio.value ? true : false}
                                value={radio.value}
                                onChange={(e) => { this.props.onFieldChanged(e.target.value); }}
                                className={this.props.error == true ? "inputError" : ""}
                            />
                            {<span dangerouslySetInnerHTML={{ __html: radio.text }}></span>}
                            {this.props.isvertical ? <br /> : ""}
                            {this.props.isvertical ? <br /> : ""}
                        </label>
                    </div>
            );
        }

        //build the className for the radios element
        var radioClassName = this.props.feRequired ? "fe-required-field" : "";

        // don't use this default style if a style is passed to the component
        var fieldsetStyle = this.props.style != null ? this.props.style : { border: '0', padding: '4px 9px 8px 0px', marginLeft: '0', height: '58px' };
        var legendClass = "";
        var legendStyle = {};
        if (this.props.isvertical == false) {
            legendClass = "label-left";
            legendStyle.paddingLeft = "0px";
        }
        if (this.props.isRequired) {
            legendStyle.float = "left";
        }

        return (
            <div>
                {this.props.isvertical ?
                    <div>
                        {this.props.isvertical ? <br /> : ""}
                        {this.props.isvertical ? <br /> : ""}
                        <fieldset className={radioClassName} style={fieldsetStyle} id={this.props.id}>
                            <legend className={legendClass} style={legendStyle}>{this.props.label || this.props.placeholder} {this.props.isRequired ? <span style={{ color: "#D01313" }}> *</span> : ""}</legend>
                            {radios}
                        </fieldset>
                    </div>
                    :
                    <div>
                        {this.props.stacklabel ? <br /> : ""}
                        <fieldset className={radioClassName} style={fieldsetStyle} id={this.props.id}>
                            <legend className={legendClass} style={legendStyle}>{this.props.label || this.props.placeholder} {this.props.isRequired ? <span style={{ color: "#D01313" }}> *</span> : ""}</legend>
                            {radios}
                        </fieldset>
                    </div>
                }
                <p style={{ margin: '0' }} className="validationError">
                    <span dangerouslySetInnerHTML={{ __html: this.props.errorText }}></span>
                </p>
            </div>
        );
    }
}

export default RadioField;
global.RadioField = RadioField;